export default class IWaitingRequest {
    constructor(
        readonly event: string,
        readonly request: any,
    ) {}

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/services/common/models/IWaitingRequest.ts